import { DashboardNotification } from '@web/dashboard/types/DashboardNotification';
import { DashboardNotificationRoute } from '@web/dashboard/types';
import type { TimesheetsDashboardNotification } from '@web/timesheets/types/TimesheetsDashboardNotification';
import type { ClockInDashboardNotification } from '@web/timesheets/types/ClockInDashboardNotification';

export const isTimesheetsDashboardNotification = (
  notification: DashboardNotification
): notification is TimesheetsDashboardNotification =>
  (notification as TimesheetsDashboardNotification).route ===
    DashboardNotificationRoute.timeclockTimesheets ||
  (notification as ClockInDashboardNotification).route === DashboardNotificationRoute.clockIn;
